import { html, when } from '@microsoft/fast-element';
import { getPrefix } from '../utils/dom';
export const getPrefixedUrlInput = (prefix) => html `
    <div class="container" value=${(x) => x.value}>
      <${prefix}-text-field
        class="url-input"
        required
        type="url"
        :value=${(x) => (x.focused && !x.readOnly ? x.value : '')}
        @blur=${(x, c) => { var _a; return (!x.readOnly ? x.saveUrl((_a = c.event) === null || _a === void 0 ? void 0 : _a.target['value']) : ''); }}
        @focus=${(x) => x.focus()}
        :readOnly=${(x) => x.readOnly}
      ></${prefix}-text-field>
      ${when((x) => x.readOnly || !x.focused, html `
          <a class="url-input-link" href=${(x) => x.value} target="_blank">${(x) => x.value}</a>
        `)}
    </div>
`;
export const foundationUrlInputTemplate = html `
  ${(x) => getPrefixedUrlInput(getPrefix(x))}
`;
